if (document.getElementById('page-reservationTable')) {
  page()
}

function page() {
  //  ######    ###    #####   ##      #####             ####   #####   ##   ##  ##     ##  ######
  //    ##     ## ##   ##  ##  ##      ##               ##     ##   ##  ##   ##  ####   ##    ##
  //    ##    ##   ##  #####   ##      #####  ########  ##     ##   ##  ##   ##  ##  ## ##    ##
  //    ##    #######  ##  ##  ##      ##               ##     ##   ##  ##   ##  ##    ###    ##
  //    ##    ##   ##  #####   ######  #####             ####   #####    #####   ##     ##    ##
  // テーブル人数を数える
  applyTableCount()

  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-tableCount')
    if (!item) {
      return
    }
    applyTableCount()
  })

  function applyTableCount() {
    const countInputList = document.getElementsByClassName('js-tableCount')

    for (const countInput of countInputList) {
      let person = 1 // 人数
      const targetName = countInput.dataset.tableCount
      const inputList = document.getElementsByClassName('js-tableCount--' + targetName)

      for (const input of inputList) {
        const value = parseInt(input.value, 10)
        person *= value
      }

      if (isNaN(person) || person <= 0) {
        person = 1
      }
      const viewItem = document.querySelector('.js-tableCount-view--' + targetName)
      viewItem.innerText = person
    }
  }
}
